var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaskConfig = function SvgTaskConfig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    fillRule: "evenodd",
    d: "M2 2a1 1 0 0 0 0-2H1a1 1 0 1 0 0 2h1Zm11 0a1 1 0 1 0 0-2H5a1 1 0 1 0 0 2h8Zm1 3a1 1 0 0 1-1 1H5a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1Zm-1 5a1 1 0 1 0 0-2H5a1 1 0 1 0 0 2h8ZM3 5a1 1 0 0 1-1 1H1a1 1 0 0 1 0-2h1a1 1 0 0 1 1 1Zm-1 5a1 1 0 1 0 0-2H1a1 1 0 1 0 0 2h1Z",
    clipRule: "evenodd"
  })));
};
export default SvgTaskConfig;